/** Shows a speaker icon that plays TTS when clicked */
import * as preact from "preact";

import * as deviceDetect from "deviceDetect";
import * as practiceUtils from "practiceUtils";
import stores from "stores/stores";
import * as tts from "tts";

interface Props {
  text: string;
  language: string;
}

interface State {}

export default class PlayTTSView extends preact.Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }

  languageSupported = (): boolean =>
    tts.getAvailabilitySignal({
      user: stores.user,
      feature: "speakingMode",
      language: this.props.language,
    }).value === "supported";

  render() {
    if (!this.languageSupported()) {
      return null;
    }

    return (
      <a
        class="playTTSButton"
        href="#"
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          practiceUtils.playTTS(this.props.language, this.props.text);
        }}
      >
        <i class="icon-volume-up"></i>
      </a>
    );
  }

  componentDidMount() {
    if (!this.languageSupported()) {
      return;
    }

    // Set up keyboard handler which plays TTS when Ctrl+P is pressed
    document.addEventListener("keydown", this.keydownHandler);
  }

  keydownHandler = (event: KeyboardEvent) => {
    if (
      (deviceDetect.info().mac && event.metaKey && event.key === "p") ||
      (!deviceDetect.info().mac && event.ctrlKey && event.key === "p")
    ) {
      event.preventDefault();
      event.stopPropagation();
      practiceUtils.playTTS(this.props.language, this.props.text);
    }
  };

  componentWillUnmount(): void {
    if (!this.languageSupported()) {
      return;
    }

    // Remove keyboard handler
    document.removeEventListener("keydown", this.keydownHandler);
  }
}
